<template>
	<div class="register_container">
		<!--遮罩层-->
		<div class="markBox"></div>
		<!--注册弹框-->
		<div class="register" ref="registerBox">
			<img class="title_reg" v-if="obj.isZXQudao" src="../../image/zx-mll.png" />
			<img
				class="title_reg"
				v-else-if="obj.isZXBZJPQudao"
				src="../../image/zxzw-bzjp-mll.png"
			/>
			<img class="title_reg" v-else-if="obj.isQudao" src="../../image/newnew-reg.png" />
			<img class="title_reg" v-else-if="!obj.isQian" src="../../image/mll-register.png" />
			<img class="title_reg" src="../../image/jieqianmll.png" v-else />
			<div class="fromBox">
				<div class="fromBox_head">
					<span class="cbb">{{ quhao }}</span>
					<span class="c4" @click.stop.prevent="getCountry">{{ guojia }}</span>
				</div>
				<div class="inputBox phoneBox">
					<input
						@blur="inputBlurHandle"
						type="text"
						name="phone"
						v-model="phoneNum"
						placeholder="输入手机号"
					/>
				</div>
				<div class="inputBox phoneBox" v-if="isGet">
					<div style="margin: 0 auto" @click.stop.prevent="sendCodeBtn">获取验证码</div>
				</div>
				<div class="inputBox" v-if="!isGet">
					<input
						@blur="inputBlurHandle"
						class="codeText"
						type="text"
						v-model="code"
						name="验证码"
						placeholder="输入验证码"
					/>
					<button v-if="!changeBtn" class="codeBtn" @click.stop.prevent="sendCode">
						重新获取
					</button>
					<button v-if="changeBtn" class="codeBtn daoshuBtn">{{ codeNum + 's' }}</button>
				</div>
				<div class="xieyiBox">
					<span
						class="service-check-box"
						@click="changCheck"
						:class="{active: isChecked}"
					></span>
					<span class="xieyi hui">我已同意</span>
					<span class="xieyi" @click.stop.prevent="gotoLink"
						>《易起问用户协议》</span
					>
				</div>
				<button class="bindBtn" v-if="obj.isQian" @click.stop.prevent="bindEvent">
					<span>大师免费解签</span>
				</button>
				<button class="bindBtn" v-else @click.stop.prevent="bindEvent">
					<span>马上提交</span>
				</button>
			</div>
			<!-- 链接跳进来的优惠券组件 -->
			<transition name="fade" mode="in-out">
				<newUserPopLink
					v-if="batchObj.isShow"
					:newUserObj="batchObj"
					@close="newUserCloseLink"
				></newUserPopLink>
			</transition>
		</div>

		<countrycom v-if="isCountry" @change="changeCode"></countrycom>
		<agreement v-if="isAgree" @close="isAgree = false"></agreement>
	</div>
</template>
<script>
import countrycom from './countryCode.vue';
import agreement from './agree.vue';
import myAjax from '../../common/js/request';
import {apiPath} from '../../common/js/config.js';
import {commonFn} from '../../common/js/common.js';
import JsEncrypt from '../../common/js/jsencrypt.min.js'; // 接口参数加密
import {Base64} from 'js-base64';
import Vue from 'vue';
import newUserPopLink from './newUserPopLink.vue';
export default {
	name: 'registercom',
	props: {
		obj: {
			type: Object
		}
	},
	components: {
		countrycom,
		agreement,
		newUserPopLink
	},
	data() {
		return {
			roomObj: null,
			channel: commonFn.getParams()['channel'] || localStorage.getItem('channel') || '',
			guojia: '中国',
			quhao: '+86',
			val: '86',
			//地区选择弹框
			isCountry: false,
			//获取验证码按钮
			changeBtn: false,
			//倒数时间
			codeNum: 90,
			//是否同意协议
			isChecked: false,
			isAgree: false,
			//表单数据
			phoneNum: '',
			code: '',
			isGet: true,

			//登录之后的流程  签文 -> 在线 -> 链接带优惠券 -> 新手流程
			qianId: commonFn.getParams()['qian_id'] || '',
			order_id: commonFn.getParams()['order_id'] || '',
			order_type: commonFn.getParams()['type'] || '',
			batch: commonFn.getParams()['batch'] || '',
			source: commonFn.getParams()['source'] || '',
			batchObj: {
				uid: '',
				isShow: false,
				data: {
					name: '',
					value: '',
					mininum: ''
				}
			}
		};
	},
	computed: {
		isDisplayCouponPop() {
			return this.$store.state.couponPop;
		}
	},
	methods: {
		async getFromId() {
			var data = {
				answer_uid: 0,
				ident: 'zxcs'
			};
			await myAjax
				.post(apiPath.getRoomId, data)
				.then((res) => {
					this.roomObj = res;
					this.$router.push({
						path: `/freeChatRoom?room=${res.room_id}&from=${res.from_uid}&channel=${this.channel}`
					});
				})
				.catch((e) => this.layer(e));
		},
		//是否同意协议
		changCheck() {
			this.isChecked = !this.isChecked;
		},
		//选择国家区号
		getCountry() {
			this.isCountry = true;
		},
		//获取验证码倒数
		getCode() {
			this.changeBtn = true;
			if (this.codeNum == 1) {
				this.changeBtn = false;
				this.codeNum = 90;
			} else {
				this.codeNum--;
				setTimeout(() => {
					this.getCode();
				}, 1000);
			}
		},
		gotoLink(){
			location.href = 'https://static-page.yiqiwen.cn/protocol/xcxyqw/user.html';
		},

		// public_key解码，手机号码加密
		decodeCode({public_key}) {
			const base64Key = Base64.decode(public_key);
			// 实例化
			let jsencrypt = new JSEncrypt();
			jsencrypt.setPublicKey(base64Key);
			// 加密数据
			return jsencrypt.encrypt(this.phoneNum);
		},
		async sendCodeBtn() {
			if (!this.phoneNum) {
				this.layer('请输入手机号码');
				return;
			} else {
				this.isGet = false;
				// 从接口获取key，base64解码
				let keyObj = await myAjax.get(apiPath.loginPublicKey),
					encryptPhoneNum = this.decodeCode(keyObj);
				this.showLoading('发送中');
				let data = {
					mobile: encryptPhoneNum,
					area: '00' + this.val
				};
				await myAjax
					.post(apiPath.loginSmsCode, data)
					.then((res) => {
						this.getCode();
					})
					.catch((e) => {
						this.layer(e);
					});
				this.hideLoading();
			}
		},
		async sendCode() {
			if (!this.phoneNum) {
				this.layer('请输入手机号码');
				return;
			} else {
				// 从接口获取key，base64解码
				let keyObj = await myAjax.get(apiPath.loginPublicKey),
					encryptPhoneNum = this.decodeCode(keyObj);

				this.showLoading('发送中');
				let data = {
					mobile: encryptPhoneNum,
					area: '00' + this.val
				};
				await myAjax
					.post(apiPath.loginSmsCode, data)
					.then((res) => {
						this.getCode();
					})
					.catch((e) => {});
				this.hideLoading();
			}
		},
		changeCode(obj) {
			this.isCountry = false;
			this.guojia = obj.guojia ? obj.guojia : '中国大陆';
			this.quhao = obj.quhao ? obj.quhao : '+86';
			this.val = obj.quhao.slice(1) || '86';
		},
		closeEvent() {
			this.$store.commit('setLoginPop', false);
		},
		layer(text, time) {
			this.$store.commit('showLayer', text);
		},
		showLoading(text) {
			this.$store.commit('showLoading', text);
		},
		hideLoading() {
			this.$store.commit('hideLoading');
		},
		// async bindEvent() {
		//     try {
		//         Vue.http.headers.common['Authorization'] = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1NDEwNTk3NDUwMDAwMDAxMCIsImlhdCI6MTU0MTA1OTc0NSwiZXhwIjoxNTcyNTk1NzQ1fQ.DvnaNjScw7Yq1GdocHkXnrsdbjvYBsAutjSnKPjnud4";
		//         this.$store.commit('setUserIsLogin',true);
		//         localStorage.setItem('yiQiWenToken',"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC95ZGFwaS5saW5naGl0LmNvbSIsImF1ZCI6IjE1NDEwNTk3NDUwMDAwMDAxMCIsImlhdCI6MTU0MTA1OTc0NSwiZXhwIjoxNTcyNTk1NzQ1fQ.DvnaNjScw7Yq1GdocHkXnrsdbjvYBsAutjSnKPjnud4");
		//         this.$store.dispatch("getIsNewUserAndHasCoupon", this.$route.path);
		//         // 登录成功之后的回调
		//         this.$emit("success");
		//     }catch (e){
		//         console.warn( e )
		//     }
		// },
		async bindEvent() {
			if (!this.phoneNum) {
				this.layer('手机号码不能为空！');
			} else if (!this.code) {
				this.layer('验证码不能为空！');
			} else if (!this.isChecked) {
				this.layer('请勾选同意协议！');
			} else {
				this.showLoading('登录中');
				_senseTrack('$Click', {
					$module: 'Binding_button_click',
					$title: '绑定按钮点击'
				});
				let data = {
					mobile: this.phoneNum,
					code: this.code,
					channel: this.channel,
					area: '00' + this.val
				};

				await myAjax
					.post(apiPath.mobileLogin, data)
					.then((res) => {
						// 获得token，把token存到本地
						if (res.token) {
							try {
								Vue.http.headers.common['Authorization'] = res.token;
								Vue.http.headers.common['YQW-Token'] = res.token;
								this.$store.commit('setUserIsLogin', true);
								localStorage.setItem('yiQiWenToken', res.token);
								commonFn.setCookieItem(
									'_token',
									res.token,
									Infinity,
									'/',
									'yiqiwen.cn'
								);
								// // 已登录用户绑定大数据userid
								// commonFn.linkUseridToSense(res.uid);
								let newUrl = location.href;
								location.replace(newUrl);
								return;
								if (this.qianId) {
									this.bindQian();
								} else if (this.source == 'around') {
									this.$router.push({
										path: `/highAnswerList?high_cate_id=7&source=around`
									});
								} else if (
									localStorage.getItem('h5orderLogin') &&
									localStorage.getItem('h5orderLogin') == 'h5orderLogin'
								) {
									localStorage.removeItem('h5orderLogin');
									window.location.reload();
								} else {
									if (this.order_id) {
										this.$emit('loginSuc');
									} else {
										if (this.batch) {
											this.$emit('hasConpon');
										} else {
											// 新手流程
											this.$store.dispatch('getIsNewUserAndHasCoupon');

											if (
												!this.isDisplayCouponPop &&
												location.pathname == '/meIndex'
											) {
												location.reload(true);
											}
										}
									}
								}
							} catch (e) {
								console.warn(e);
							}
						} else {
							this.layer('token不存在');
						}
					})
					.catch((e) => {
						this.layer(e);
					});
				this.hideLoading();
			}
		},
		/* 绑定签文id */
		bindQian() {
			myAjax
				.post(apiPath.bindQian, {id: this.qianId})
				.then((res) => {
					/* 跳转到我的签问页面 */
					this.$router.push({
						path: '/meQian'
					});
				})
				.catch((e) => {});
		},
		/*短信优惠券链接*/
		coupon() {
			myAjax
				.post(apiPath.couponApi, {
					batch: this.batch
				})
				.then((res) => {
					if (res.amount) {
						this.batchObj.isShow = true;
						this.batchObj.data = res;
					} else {
						this.batchObj.isShow = false;
						if (res.status == -1) {
							this.layer(res.msg, 2000);
							// 新手流程
							this.$store.dispatch('getIsNewUserAndHasCoupon', this.$route.path);
							if (res.url) {
								setTimeout(() => {
									location.href = res.url;
								}, 2000);
							}
						}
					}
				})
				.catch((e) => {});
		},
		newUserCloseLink() {
			this.batchObj.isShow = false;
			commonFn.showFooter();
		},
		inputBlurHandle() {
			try {
				this.$refs.registerBox.scrollIntoViewIfNeeded();
			} catch (error) {
				console.log('不支持scrollIntoViewIfNeeded()');
			}
		}
	},
	mounted() {}
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.fromBox_head {
	text-align: center;
	margin: 0.533rem 0 0.133rem;
	font-size: 0.427rem;
	color: #e04e3e;
}
.isNone {
	color: #7d7d7d;
}
.title_reg {
	display: block;
	width: 100%;
	margin-top: -0.587rem;
}
.register_container {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 9999;
}
.markBox {
	background: #000000;
	opacity: 0.7;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1000;
}
.register {
	width: 8.667rem;
	background: #fff;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	padding-bottom: 0.533rem;
	z-index: 1001;
	border-radius: 0.133rem;
	box-sizing: border-box;
	.text {
		display: none;
	}
	.height1 {
		width: 100%;
		height: 1.867rem;
		margin-top: 1.867rem;
	}
	.height2 {
		display: none;
	}
}
.register2 {
	width: 7.520rem;
	background: #fff;
	height: 9.280rem;
	position: absolute;
	top: 50%;
	left: 50%;
	margin-top: -4.640rem;
	margin-left: -3.760rem;
	z-index: 1001;
	border-radius: 0.133rem;
	box-sizing: border-box;
	.height1 {
		display: none;
	}
	.height2 {
		width: 100%;
		height: 0.933rem;
		margin-top: 0.933rem;
	}
	.reg_bg {
		width: 7.520rem;
		height: 3.520rem;
		background: url(../../image/yce-phone.png) no-repeat center center;
		background-size: 7.520rem 3.520rem;
		margin-top: -0.293rem;
		margin-bottom: 0.507rem;
	}
	.people {
		display: none;
	}
	.hand {
		display: none;
	}
	.text {
		font-size: 0.347rem;
		color: #fa6048;
		text-align: center;
		position: absolute;
		left: 0;
		width: 100%;
		top: 0.667rem;
	}
}
.inputBox {
	width: 6.960rem;
	height: 1.333rem;
	background: #fff;
	margin: 0 auto;
	box-sizing: border-box;
	padding-top: 0.347rem;
	border-bottom: 1px solid #eaeaea;
	text-align: center;
}
.bindBtn {
	width: 6.960rem;
	line-height: 1.333rem;
	background: #fff;
	margin: 0 auto;
	color: #fff;
	display: block;
	padding: 0.067rem;
	font-size: 0.533rem;
	outline: none;
	border: 1px solid #e04e3e;
	span {
		display: block;
		width: 100%;
		background: #e04e3e;
		line-height: 1.200rem;
	}
}
.service-check-box {
	display: inline-block;
	width: 0.347rem;
	height: 0.347rem;
	vertical-align: middle;
	overflow: hidden;
	margin-top: -0.040rem;
	margin-right: 0.133rem;
	border: 1px solid #eaeaea;
	&.active {
		background: #e04e3e url(../../image/service-checked.png) no-repeat center center/0.253rem 0.253rem;
		border: none;
	}
}
.xieyi {
	font-size: 0.347rem;
	color: #fa6048;
	display: inline-block;
	vertical-align: middle;
	&.hui {
		color: #999999;
	}
}
.xieyiBox {
	width: 6.960rem;
	margin: 0 auto;
	margin-bottom: 0.533rem;
	margin-top: 0.533rem;
	font-size: 0.347rem;
}
.codeText {
	width: 2.933rem;
	line-height: 0.693rem;
	font-size: 0.400rem;
	padding: 0;
	text-align: center;
	padding-left: 0.267rem;
	border: none;
	margin: 0;
	background: transparent;
}
.codeBtn {
	/*width: 2.667rem;
        line-height: 0.667rem;*/
	color: #333;
	border: none;
	/*border: 1px solid #fa6048;
        border-radius: 0.067rem;
        padding: 0;*/
	background: #fff;
	outline: none;
	font-size: 0.347rem;
	/*&.daoshuBtn{
            background: #cdcdcd;
            color: #fff;
            border: none;
        }*/
}
.phoneBox {
	font-size: 0.320rem;
	padding-left: 0.267rem;
	input,
	div {
		margin: 0;
		padding: 0;
		font-size: 0.427rem;
		width: 4.267rem;
		background: none;
		border: none;
		text-align: center;
	}
}
</style>



// WEBPACK FOOTER //
// newRegisterV2.vue?dd91f85e